<div [ngClass]="['switch-accounts-overlay', visible ? 'show' : '']">
    <div class="switch-accounts-container">
        <div data-cy="user-side-menu-info-text" class="text light description">
            {{ "user.switch.account.description" | translate }}
        </div>
        <div>
            <div class="role-btn-container">
                <div
                    data-cy="user-side-menu-role-container"
                    [ngClass]="[
                        'role-btn',
                        roleType.role === currentUserType ? 'active' : ''
                    ]"
                    *ngFor="let roleType of roleTypeArray"
                    (click)="
                        roleType.role !== currentUserType
                            ? onSelectedRole(roleType)
                            : ''
                    "
                >
                    <img src="assets/icons/user-profile.svg" />
                    <div
                        data-cy="user-side-menu-role-name"
                        class="caption-small light"
                    >
                        {{ roleType.role }}
                    </div>
                </div>
            </div>
        </div>
        <div
            data-cy="user-side-menu-logout-button"
            class="logout-btn text-large"
            (click)="onSignOutClick()"
        >
            {{ "header.ops.signout" | translate }}
        </div>
    </div>
</div>
